<template>

<div>
    <label v-if="titlebefore" class="titlebefore">{{ titlebefore }}</label>
    <label v-html="label"></label>

      <div style="display:inline-block;padding-right:2em;" v-for="(v,idx) in selection" :key="idx">

        <div class="flex">
          <input @input="$emit('update', $event.target.value)" v-model="value" :value='v' :name="'i' + index + v" :id="'i' + index + v" type="radio" />
          <label :for="'i' + index + v">{{ v }} </label>
        </div>
      </div>
    <div class="remarks">{{ remarks }}</div>
</div>

</template>

<script>
export default {

    data: function() {
          return  {
              data: this.currentvalues ? this.currentvalues : false
          }
      },
  props: ["value","label","selection","index","titlebefore","remarks","currentvalue"],


   computed:{
    counts() {
      var repeats = [];
      var r = 1;
      if(this.repeats){
        r = parseInt(this.repeats);
      }
      for(let i = 1; i <= r; i++){
        repeats.push(i)
      }
      return repeats
    },
   },
  model: {
    prop: "value",
    event: "update"
  }
};
</script>
